import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import RadioGroup from '@material-ui/core/RadioGroup';

const styles = theme => ({
  root: {
    '& label': {
      marginRight: 15,
      marginTop: -5,
      marginBottom: -5,
      [theme.breakpoints.down('sm')]: {
        marginRight: 8,
      },
    },
  },
  directionRow: {
    flexDirection: 'row',
  },
  directionColumn: {
    flexDirection: 'column',
  },
});

const RadioGroupField = ({ input, direction, classes, ...otherProps }) => (
  <RadioGroup
    {...input}
    {...otherProps}
    className={classNames(classes.root, {
      [classes.directionRow]: direction === 'row',
      [classes.directionColumn]: direction === 'column',
    })}
    value={input.value}
    onChange={(event, value) => input.onChange(value)}
  />
);

RadioGroupField.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
  direction: PropTypes.oneOf(['row', 'column']),
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    directionRow: PropTypes.string.isRequired,
    directionColumn: PropTypes.string.isRequired,
  }).isRequired,
};

RadioGroupField.defaultProps = {
  direction: 'row',
};

export default withStyles(styles)(RadioGroupField);



// WEBPACK FOOTER //
// ./src/components/fields/RadioGroupField.js